'use client'

import React from 'react'
import Link from 'next/link'
import { Button } from '@mantine/core'

interface NavPillButtonProps {
    href: string
    label: string
    onClick?: () => void
    icon?: React.ReactNode
    'data-testid'?: string
}

export function NavPillButton({ href, label, onClick, icon, ...rest }: NavPillButtonProps) {
    return (
        <Button
            variant="default"
            component={Link}
            href={href}
            onClick={onClick}
            radius="999px"
            h={44}
            px={20}
            fz={14}
            fw={500}
            c="var(--gm-fg-primary-black, #1f1e1d)"
            bd="1px solid var(--Foreground-fg-outline-primary, #D1D0CF)"
            leftSection={icon}
            __vars={{
                '--button-bg': 'transparent',
                '--button-hover': 'var(--gm-bg-highlight-cont, rgba(45, 26, 255, 0.1))',
            }}
            {...rest}
        >
            {label}
        </Button>
    )
}
